export default __webpack_public_path__ + "6c30ba8a5c501632c87c826534b97a12.svg";